import { render, staticRenderFns } from "./selectSender.vue?vue&type=template&id=cf4d7640&scoped=true&"
import script from "./selectSender.vue?vue&type=script&lang=js&"
export * from "./selectSender.vue?vue&type=script&lang=js&"
import style0 from "./selectSender.vue?vue&type=style&index=0&id=cf4d7640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4d7640",
  null
  
)

export default component.exports